import { Entry } from '../Entry'

export function Entry20260702() {
  return (
    <Entry title="2026 Jul 2 - v3.11.16">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RO/versions/26904/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
